import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import DialogProvider from "./components/Dialog";
import {} from "./locales/i18";
import { Provider } from "react-redux";
import { OverFlowProvider } from "./context/OverFlowContext";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <DialogProvider>
          <OverFlowProvider>
            <AuthProvider>
              <Toaster
                position="top-center"
                duration={2000}
                theme="light"
                richColors={true}
              />
              <App />
            </AuthProvider>
          </OverFlowProvider>
        </DialogProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
